import React, { useEffect } from 'react';
import RegistAccountBody from '../components/login/RegistAccountBody';

const RegistAccountScreen = () => {
    const [step, setStep] = React.useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            style={{
                backgroundColor: 'white',
                height: '100%',
            }}
        >
            <RegistAccountBody />
        </div>
    );
};

export default RegistAccountScreen;
